import React from 'react'

import AdvancedNameSection from '../sections/AdvancedNameSection'
import NameSection from '../sections/NameSection'
import RightDatesSection from '../../../ReusableSections/RightDatesSection'
import SocialMediaAccountsSection from '../../../ReusableSections/SocialMediaAccountsSection'
import BrandKeywordsSection from '../../../ReusableSections/BrandKeywordsSection'
import RightAllocationAndDelivery from '../../../ReusableSections/RightAllocationAndDelivery'
import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'

import useIsAdvancedPartnership from '../../../../../../../features/hooks/useIsAdvancedPartnership'

function PostsRightEditSections({ formik }) {
  const isAdvancedPartnership = useIsAdvancedPartnership()

  // display simplified amount of sections for advanced partnership post right edit
  if (isAdvancedPartnership) {
    return (
      <>
        <AdvancedNameSection formik={formik} />
        <SocialMediaAccountsSection formik={formik} />
        <BrandKeywordsSection formik={formik} />
      </>
    )
  }

  return (
    <>
      <NameSection formik={formik} />
      <RightDatesSection formik={formik} />
      <SocialMediaAccountsSection formik={formik} />
      <BrandKeywordsSection formik={formik} />
      <RightAllocationAndDelivery
        formik={formik}
        sectionDescription="Please enter the number of social posts to be provided under this right."
        showUnitsField={false}
      />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default PostsRightEditSections
